import { render, staticRenderFns } from "./TwoFactorAuthenticationSetUp.vue?vue&type=template&id=6d221741&scoped=true"
import script from "./TwoFactorAuthenticationSetUp.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationSetUp.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuthenticationSetUp.vue?vue&type=style&index=0&id=6d221741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d221741",
  null
  
)

export default component.exports